<p-tabView (onChange)="onTabChange($event)">
  <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
    <div>
      <p-multiSelect 
        styleClass="ml-2 fieldFilterControl" 
        [options]="listeService.opzioniRegioneProntofibra"
        [showToggleAll]="false"
        optionLabel="label"
        optionValue="value"
        (onChange)="filtraPerRegione($event.value)"
        placeholder="Regione"
        [showClear]="false"
        [filter]="false"
        [showHeader]="false"
        [(ngModel)]="filtroRegione"
      />
      <button *ngIf="filterIsSet" pButton type="button" icon="pi pi-filter-slash" class="ml-2"
        style="background-color: #85C7E7; border-color:#191a1b; color: #191a1b; font-size: 13px;" 
        pTooltip="Rimuovi filtro" tooltipPosition="top" (click)="removeFilter()"
      ></button>
    </div>
    
     <div class="p-2" style="border-radius: 10px; background-color: #85C7E7; display: flex; justify-content: center; align-items: center; height: 100%;">
      <span 
        class="text-right font-['Poppins']" 
        style="color: #191a1b; font-size: medium; font-weight: 600;"  
      >{{labelRegioni}}</span>
    </div>
   <!-- [(ngModel)]="filtroPratiche.tipo"  (onChange)="filtraPratiche($event)" -->
    <button 
    pButton type="button" icon="pi pi-cloud-download"
    pTooltip="Esporta i dati" tooltipPosition="top"
    class="font-['Poppins']"
    style="background-color:#ffffff; color: #191a1b; border-color: #191a1b; font-size: 12px;"
    (click)="scaricaReportSopralluoghi()" 
  ></button>
  </div>
  <p-tabPanel header="Bando 1">
    <div>
      <p-table styleClass="p-datatable-sm" 
        [selectionPageOnly]="true" [rowHover]="true" [showCurrentPageReport]="true"
        [paginator]="false" [loading]="isLoading" [value]="datiRaggruppatiBando1Filtrati" dataKey="impresa" [(selection)]="selectedPraticaBando1KO">
        <ng-template pTemplate="header">
          <tr>
            <th class="text-left font-['Poppins']"   style="font-size: 11px; width: 20%; ">IMPRESA</th>
            <!-- <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">APPUNT. DA PRENDERE (PF IN ATTESA)</th> -->
            
             <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">MANCA PF<br>(NO NTW)</th>
             <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">MANCA PF<br>(CON NTW)</th>
          
            <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">APPUNT. DA PRENDERE<br>(PF PRONTO)</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">APPUNTAMENTO FISSATO</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">APPUNTAMENTO SCADUTO</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">ATTIVAZIONE KO</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">INSTALLAZIONE OK</th>   
            <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">ATTIVAZIONE OK</th>        
            <th class="text-center font-['Poppins'] font-bold" style="font-size: 11px;width: 10%;">TOTALE</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>
              <p-tag [value]="row.impresa | uppercase"
                [style]="{
                  'background-color': '#5f9ea0',
                  'color': '#ffffff',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                  'cursor': 'pointer'
                }"
                 (click)="openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'ALL')"
                [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" 
                tooltipPosition="top">
              </p-tag>
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.noAppuntamentoMancaPF_noNTW"
              [style]="{
               'background-color': '#EBEBEB',
                'color': '#000000',
                'border-radius': '6px',
                'border-color':'#0A0A0A',
                'padding': '.25em .5rem',
                'font-weight': '700',
                'font-size': '13px',
                'letter-spacing': '.3px;',
                'cursor': !isPresidioTIM && row.noAppuntamentoMancaPF_noNTW > 0 ? 'pointer': 'default'
              }"
               (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa, 'noAppuntamentoMancaPF_noNTW')"
               [pTooltip]="!isPresidioTIM && row.noAppuntamentoMancaPF_noNTW > 0 ?'Apri le pratiche SENZA PF e SENZA NTW di ' + row.impresa:null" tooltipPosition="top"
              ></p-tag> 
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.noAppuntamentoMancaPF_conNTW"
              [style]="{
                'background-color': '#EBEBEB',
                'color': '#000000',
                'border-radius': '6px',
                'border-color':'#0A0A0A',
                'padding': '.25em .5rem',
                'font-weight': '700',
                'font-size': '13px',
                'letter-spacing': '.3px;',
                'cursor': !isPresidioTIM && row.noAppuntamentoMancaPF_conNTW > 0 ? 'pointer': 'default'
              }"
               (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'noAppuntamentoMancaPF_conNTW')"
               [pTooltip]="!isPresidioTIM && row.noAppuntamentoMancaPF_conNTW > 0 ? 'Apri le pratiche SENZA PF e CON NTW di ' + row.impresa: null" tooltipPosition="top"
              ></p-tag>
            </td>
            
           
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.noAppuntamentoPFPronto"
              [style]="{
                'background-color': '#EBEBEB',
                'color': '#000000',
                'border-radius': '6px',
                'border-color':'#0A0A0A',
                'padding': '.25em .5rem',
                'font-weight': '700',
                'font-size': '13px',
                'letter-spacing': '.3px;',
                'cursor': !isPresidioTIM && row.noAppuntamentoPFPronto > 0 ? 'pointer': 'default'
              }"
               (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'noAppuntamentoPFPronto')"
               [pTooltip]="!isPresidioTIM && row.noAppuntamentoPFPronto > 0 ? 'Apri le pratiche SENZA APPUNTAMENTO E CON PF PRONTO di ' + row.impresa: null" tooltipPosition="top"
              ></p-tag>
          
            </td>
            <td class="text-center font-['Poppins']">
                <p-tag [value]="row.appuntamentoFissato"
                  [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '700',
                    'font-size': '13px',
                    'letter-spacing': '.3px;',
                    'cursor': !isPresidioTIM && row.appuntamentoFissato > 0 ? 'pointer': 'default'
                  }"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'appuntamentoFissato')"
                  [pTooltip]="!isPresidioTIM && row.appuntamentoFissato > 0 ? 'Apri le pratiche CON APPUNTAMENTO PIANFICATO di ' + row.impresa: null" tooltipPosition="top"
                  ></p-tag>
            
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.appuntamentoScaduto"
                [style]="{
                   'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                  'cursor': !isPresidioTIM && row.appuntamentoScaduto > 0 ? 'pointer': 'default'
                }"
                (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'appuntamentoScaduto')"
                [pTooltip]="!isPresidioTIM && row.appuntamentoScaduto > 0 ? 'Apri le pratiche CON APPUNTAMENTO SCADUTO di ' + row.impresa: null" tooltipPosition="top"
                ></p-tag>
             
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.attivazioneKO"
                [style]="{
                  'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                  'cursor': !isPresidioTIM && row.attivazioneKO > 0 ? 'pointer': 'default'
                }"
                 (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'attivazioneKO')"
                 [pTooltip]="!isPresidioTIM && row.attivazioneKO > 0 ? 'Apri le pratiche CON KO ATTIVAZIONE di ' + row.impresa : null"
                 tooltipPosition="top"
                ></p-tag>
           
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.attivazioneOK"
                [style]="{
                  'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                  'cursor': !isPresidioTIM && row.attivazioneOK > 0 ? 'pointer': 'default'
                }"
                 (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'attivazioneOK')"
                 [pTooltip]="!isPresidioTIM && row.attivazioneOK > 0 ? 'Apri le pratiche CON INSTALLAZIONE OK di ' + row.impresa : null"
                 tooltipPosition="top"
                ></p-tag>
           
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.installazioneOK"
                [style]="{
                 'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                  'cursor': !isPresidioTIM && row.installazioneOK > 0 ? 'pointer': 'default'
                }"
                 (click)="!isPresidioTIM && openPraticheFase2DiImpresa(1,row.idImpresa,row.impresa,'installazioneOK')"
                 [pTooltip]="!isPresidioTIM && row.installazioneOK > 0 ? 'Apri le pratiche CON ATTIVAZIONE OK di ' + row.impresa : null"
                 tooltipPosition="top"
                ></p-tag>
           
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.totale"
                [style]="{
                   'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '14px',
                  'letter-spacing': '.3px;',
                }"
                >
              </p-tag>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td colspan="1" class="text-left" style="font-size: 12px; font-weight: bold;">TOTALI:</td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando1NoAppuntamentoMancaPF_noNTW"
                [style]="{
                  'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
              </p-tag>
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando1NoAppuntamentoMancaPF_conNTW"
                [style]="{
                   'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>
            </td>
           
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando1NoAppuntamentoPFPronto"
                [style]="{
                  'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>
             <!--  {{totaliNoSopralluogoPFBando1}} -->
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando1AppuntamentoFissato"
                [style]="{
                  'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>
             <!--  {{totaliSopralluogoPianificatoBando1}} -->
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando1AppuntamentoScaduto"
                [style]="{
                 'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando1AttivazioneKO"
                [style]="{
                  'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
              </p-tag>
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando1AttivazioneOK"
                [style]="{
                  'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
              </p-tag>
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando1installazioneOK"
                [style]="{
                  'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
              </p-tag>
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando1"
                [style]="{
                  'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>
              <!-- {{totaliNoSopralluogoBando1 + totaliNoSopralluogoPFBando1 + totaliSopralluogoPianificatoBando1 + totaliSopralluogoEseguitoBando1}} -->
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-tabPanel>

  <p-tabPanel header="Bando 2">
    <div>
      <p-table styleClass="p-datatable-sm" [sortField]="'impresa'" e [sortOrder]="1"
        [selectionPageOnly]="true" [rowHover]="true" [showCurrentPageReport]="true"
        [paginator]="false" [loading]="isLoading" [value]="datiRaggruppatiBando2Filtrati" dataKey="impresa" [(selection)]="selectedPraticaBando2KO">
        <ng-template pTemplate="header">
          <tr>
            <th class="text-left font-['Poppins']" style="font-size: 11px; width: 20%;">IMPRESA</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">MANCA PF<br>(NO NTW)</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">MANCA PF<br>(CON NTW)</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">APPUNT. DA PRENDERE<br>(PF PRONTO)</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">APPUNTAMENTO FISSATO</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">APPUNTAMENTO SCADUTO</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">ATTIVAZIONE KO</th>
            <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">INSTALLAZIONE OK</th>    
            <th class="text-center font-['Poppins']" style="font-size: 11px;width: 10%;">ATTIVAZIONE OK</th>
       
            <th class="text-center font-['Poppins'] font-bold" style="font-size: 11px;width: 10%;">TOTALE</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>
              <p-tag [value]="row.impresa | uppercase"
                [style]="{
                  'background-color': '#5f9ea0',
                  'color': '#ffffff',
                  'border-radius': '6px',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                  'cursor': 'pointer'
                }"
                 (click)="openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'ALL')"
                 [pTooltip]="isPresidioTIM ? 'Apri le pratiche di ' +row.impresa + ' in carico al presidio' : 'Apri le pratiche di ' + row.impresa" tooltipPosition="top">
              </p-tag>
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.noAppuntamentoMancaPF_noNTW"
              [style]="{
                 'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                'padding': '.25em .5rem',
                'font-weight': '700',
                'font-size': '13px',
                'letter-spacing': '.3px;',
                'cursor': !isPresidioTIM && row.noAppuntamentoMancaPF_noNTW > 0 ? 'pointer': 'default'
              }"
               (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa, 'noAppuntamentoMancaPF_noNTW')"
               [pTooltip]="!isPresidioTIM && row.noAppuntamentoMancaPF_noNTW > 0 ?'Apri le pratiche SENZA PF e SENZA NTW di ' + row.impresa:null" tooltipPosition="top"
              ></p-tag>
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.noAppuntamentoMancaPF_conNTW"
              [style]="{
                'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                'padding': '.25em .5rem',
                'font-weight': '700',
                'font-size': '13px',
                'letter-spacing': '.3px;',
                'cursor': !isPresidioTIM && row.noAppuntamentoMancaPF_conNTW > 0 ? 'pointer': 'default'
              }"
               (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'noAppuntamentoMancaPF_conNTW')"
               [pTooltip]="!isPresidioTIM && row.noAppuntamentoMancaPF_conNTW > 0 ? 'Apri le pratiche SENZA PF e CON NTW di ' + row.impresa: null" tooltipPosition="top"
              ></p-tag>
            </td>
           
            
           
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.noAppuntamentoPFPronto"
              [style]="{
                'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                'padding': '.25em .5rem',
                'font-weight': '700',
                'font-size': '13px',
                'letter-spacing': '.3px;',
                'cursor': !isPresidioTIM && row.noAppuntamentoPFPronto > 0 ? 'pointer': 'default'
              }"
               (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'noAppuntamentoPFPronto')"
               [pTooltip]="!isPresidioTIM && row.noAppuntamentoPFPronto > 0 ? 'Apri le pratiche SENZA APPUNTAMENTO E CON PF PRONTO di ' + row.impresa: null" tooltipPosition="top"
              ></p-tag>
          
            </td>
            <td class="text-center font-['Poppins']">
                <p-tag [value]="row.appuntamentoFissato"
                  [style]="{
                     'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                    'padding': '.25em .5rem',
                    'font-weight': '700',
                    'font-size': '13px',
                    'letter-spacing': '.3px;',
                    'cursor': !isPresidioTIM && row.appuntamentoFissato > 0 ? 'pointer': 'default'
                  }"
                  (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'appuntamentoFissato')"
                  [pTooltip]="!isPresidioTIM && row.appuntamentoFissato > 0 ? 'Apri le pratiche CON APPUNTAMENTO PIANFICATO di ' + row.impresa: null" tooltipPosition="top"
                  ></p-tag>
            
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.appuntamentoScaduto"
                [style]="{
                   'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                  'cursor': !isPresidioTIM && row.appuntamentoScaduto > 0 ? 'pointer': 'default'
                }"
                (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'appuntamentoScaduto')"
                [pTooltip]="!isPresidioTIM && row.appuntamentoScaduto > 0 ? 'Apri le pratiche CON APPUNTAMENTO SCADUTO di ' + row.impresa: null" tooltipPosition="top"
                ></p-tag>
             
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.attivazioneKO"
                [style]="{
                   'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                  'cursor': !isPresidioTIM && row.attivazioneKO > 0 ? 'pointer': 'default'
                }"
                 (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'attivazioneKO')"
                 [pTooltip]="!isPresidioTIM && row.attivazioneKO > 0 ? 'Apri le pratiche CON KO ATTIVAZIONE di ' + row.impresa : null"
                 tooltipPosition="top"
                ></p-tag>
           
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.attivazioneOK"
                [style]="{
                   'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                  'cursor': !isPresidioTIM && row.attivazioneOK > 0 ? 'pointer': 'default'
                }"
                 (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'attivazioneOK')"
                 [pTooltip]="!isPresidioTIM && row.attivazioneOK > 0 ? 'Apri le pratiche CON INSTALLAZIONE OK di ' + row.impresa : null"
                 tooltipPosition="top"
                ></p-tag>
           
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.installazioneOK"
                [style]="{
                  'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                  'cursor': !isPresidioTIM && row.installazioneOK > 0 ? 'pointer': 'default'
                }"
                 (click)="!isPresidioTIM && openPraticheFase2DiImpresa(2,row.idImpresa,row.impresa,'installazioneOK')"
                 [pTooltip]="!isPresidioTIM && row.installazioneOK > 0 ? 'Apri le pratiche CON ATTIVAZIONE OK di ' + row.impresa : null"
                 tooltipPosition="top"
                ></p-tag>
           
            </td>
            <td class="text-center font-['Poppins']">
              <p-tag [value]="row.totale"
                [style]="{
                   'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '700',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
              </p-tag>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr>
            <td colspan="1" class="text-left" style="font-size: 12px; font-weight: bold;">TOTALI:</td>
           
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando2NoAppuntamentoMancaPF_noNTW"
              [style]="{
                 'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                'padding': '.25em .5rem',
                'font-weight': '800',
                'font-size': '13px',
                'letter-spacing': '.3px;',
              }"
              >
            </p-tag>
          </td>
          <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
            <p-tag [value]="totaliBando2NoAppuntamentoMancaPF_conNTW"
                [style]="{
                    'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>      
          </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando2NoAppuntamentoPFPronto"
                [style]="{
                 'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>
             <!--  {{totaliNoSopralluogoPFBando1}} -->
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando2AppuntamentoFissato"
                [style]="{
                   'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>
             <!--  {{totaliSopralluogoPianificatoBando1}} -->
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando2AppuntamentoScaduto"
                [style]="{
                  'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando2AttivazioneKO"
                [style]="{
                   'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
              </p-tag>
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando2AttivazioneOK"
                [style]="{
                   'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
              </p-tag>
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando2installazioneOK"
                [style]="{
                  'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
              </p-tag>
            </td>
            <td class="text-center font-['Poppins']" style="font-size: 12px; font-weight: bold;">
              <p-tag [value]="totaliBando2"
                [style]="{
                 'background-color': '#EBEBEB',
                    'color': '#000000',
                    'border-radius': '6px',
                    'border-color':'#0A0A0A',
                  'padding': '.25em .5rem',
                  'font-weight': '800',
                  'font-size': '13px',
                  'letter-spacing': '.3px;',
                }"
                >
            </p-tag>
              <!-- {{totaliNoSopralluogoBando1 + totaliNoSopralluogoPFBando1 + totaliSopralluogoPianificatoBando1 + totaliSopralluogoEseguitoBando1}} -->
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-tabPanel>
</p-tabView>
